// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-height[data-v-43690313] {\n  height: 100%;\n}\n.esikatselu[data-v-43690313] {\n  height: 60vh;\n}\n.main-div[data-v-43690313] {\n  min-height: calc(100vh - 64px);\n}", ""]);
// Exports
module.exports = exports;
